import React, { useEffect, useState } from "react";
import "../CSS/cart.css";
import { Button } from "@chakra-ui/react";
import { Link as NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearCart, getCart } from "../Redux/action";
import { API } from "../API/api";

function Cart() {
  const { token } = useSelector((e) => e.auth);
  const dispatch = useDispatch();
  let data = useSelector((e) => e.product.cart);

  useEffect(() => {
    dispatch(getCart(token));
  }, []);

  const handleQuantityChange = async (productId, change) => {
    try {
      const response = await fetch(`${API}/users/cart/quantity`, {
        method: "PATCH", // or POST, depending on your backend setup
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // if using JWT auth
        },
        body: JSON.stringify({
          productId,
          quantity: change, // send +1 or -1
        }),
      });

      const result = await response.json();

      if (response.ok) {
        // Refresh the cart state
        dispatch(getCart(token));
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
    }
  };

  function clearCartItem() {
    dispatch(clearCart());
  }

  let total = 0;
  data?.data?.cart?.map((el) => (total += el.quantity * +el.Price));

  if (data?.data?.cart?.length === 0)
    return (
      <>
        <h1 style={{ fontSize: "100px" }}>Cart Empty!</h1>
        <NavLink to="/product">
          {" "}
          <Button m="20px">Continue Shopping</Button>
        </NavLink>
      </>
    );
  if (data?.data?.cart?.length > 0) {
    return (
      <div>
        <h1 style={{ fontSize: "50px" }}>Your Orders</h1>
        {data?.data?.cart?.map((el) => (
          <div key={el.id} className="cart">
            <img width="10%" src={el.image} alt="" />
            <div>
              <Button
                m="5px"
                colorScheme="red"
                isDisabled={el.quantity === 1}
                onClick={() => handleQuantityChange(el.productId, -1)}
              >
                -
              </Button>
              <b>{el.quantity}</b>
              <Button
                m="5px"
                colorScheme="blue"
                onClick={() => handleQuantityChange(el.productId, 1)}
              >
                +
              </Button>
            </div>
            <p>
              <b>₹{el.Price * el.quantity}</b>
            </p>
            <Button
              colorScheme="red"
              // onClick={() => removeItem(el)}
            >
              Remove
            </Button>
          </div>
        ))}
        <div className="bill">
          <h1>Total Amount:{total}</h1>
          <h2>GST(18%):{(total * 18) / 100}</h2>
          <h1>
            <b>Total:{Math.ceil(total + (total * 18) / 100)}</b>
          </h1>
          <Button
            m="10px"
            onClick={() => clearCartItem()}
          >
            Make Payment
          </Button>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        {" "}
        <h1 style={{ fontSize: "100px" }}>Cart Empty!</h1>
        <NavLink to="/product">
          {" "}
          <Button m="20px">Continue Shopping</Button>
        </NavLink>
      </div>
    );
  }
}

export default Cart;
